
import {Component, Prop, Vue} from "vue-property-decorator";
import {isMobileOnly} from "mobile-device-detect";

  @Component({})
  export default class WarningMessage extends Vue {
    @Prop() animateWarning: boolean;
    isMobileOnly;

    created() {
      this.isMobileOnly = isMobileOnly;
    }

    revertChanges() {
      this.$emit('revertChanges');
    }
  }
